<form [formGroup]="group" class="row justify-content-center">
  <div class="col-12 col-md-10 py-4">
    <div class="row">
      <div class="col-md-6 mb-3">
        <div class="form-floating">
          <input
            id="name"
            formControlName="name"
            [ngClass]="validate('name')"
            type="text"
            class="form-control" />
          <label for="name">
            <span class="text-danger small">*</span>
            Your Name
          </label>
        </div>
      </div>
      <div class="col-md-6 mb-3">
        <div class="form-floating">
          <input
            id="email"
            formControlName="email"
            [ngClass]="validate('email')"
            type="text"
            class="form-control" />
          <label for="name">
            <span class="text-danger small">*</span>
            Your Email
          </label>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-floating">
          <select
            id="community"
            formControlName="community"
            [ngClass]="validate('community')"
            class="form-select">
            <option>Type or select an option</option>
            <option
              *ngFor="let item of module.communities$ | async"
              [value]="item.id">
              {{ item.name }}
            </option>
          </select>
          <label for="community">
            <span class="text-danger small">*</span>
            What community are you with ?
          </label>
        </div>
      </div>
    </div>
  </div>
</form>
